import { motion } from "framer-motion";

const PILLARS = [
  {
    n: "01",
    title: "Venture Studio",
    body: "We originate, co-build, and operate companies alongside founders solving structural problems in fashion.",
  },
  {
    n: "02",
    title: "Founder Support",
    body: "Hands-on operating leverage — go-to-market, hiring, brand, supply chain, and capital strategy.",
  },
  {
    n: "03",
    title: "Strategic Partnerships",
    body: "Deep relationships across designers, retailers, manufacturers, and creator networks unlock distribution.",
  },
  {
    n: "04",
    title: "Infrastructure & Technology",
    body: "We back the picks-and-shovels of modern fashion — the rails that enable scale, transparency, and reach.",
  },
  {
    n: "05",
    title: "Selective Capital Access",
    body: "We deploy and syndicate capital with conviction, alongside aligned institutional partners.",
  },
];

export default function WhatWeDo() {
  return (
    <section
      id="what-we-do"
      data-testid="whatwedo-section"
      className="relative bg-black text-white border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-28 md:py-40">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-16 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50">
              §02 — What we do
            </p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              A studio of <span className="italic font-light">operators</span> —
              not a fund of spectators.
            </motion.h2>
          </div>
        </div>

        <div className="border-t border-white/10">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              data-testid={`pillar-${p.n}`}
              className="group grid grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-white/10 hover:bg-white/[0.02] transition-colors duration-500 cursor-default"
            >
              <div className="col-span-2 md:col-span-1">
                <span className="font-serif text-2xl md:text-3xl text-white/40 group-hover:text-white transition-colors">
                  {p.n}
                </span>
              </div>
              <div className="col-span-10 md:col-span-5">
                <h3 className="font-serif text-2xl md:text-4xl text-white tracking-tight">
                  {p.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-6">
                <p className="text-white/65 text-base md:text-lg font-light leading-relaxed max-w-xl">
                  {p.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
